import { type ClassValue, clsx } from 'clsx'

export function cn(...inputs: ClassValue[]) {
  return clsx(inputs)
}

export function formatPrice(price: number): string {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(price)
}

export function formatDate(date: string | Date): string {
  return new Intl.DateTimeFormat('fr-FR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(new Date(date))
}

export function calculateSavings(monthly: number, yearly: number): number {
  return monthly * 12 - yearly
}

export function calculateSavingsPercentage(monthly: number, yearly: number): number {
  const savings = calculateSavings(monthly, yearly)
  return Math.round((savings / (monthly * 12)) * 100)
}
